module.exports = __webpack_public_path__ + "5071f6d3e398102f009d3e2b07c97767.woff";